const EVENT_KEY = 'EVENT_LIST';

export default EVENT_KEY;
